export default "__VITE_ASSET__7eea3962__"